import { Resources } from '@app/resources';
import { Routes } from '@angular/router';

export default [
  {
    path: Resources.Invoices,
    loadComponent: () => import('./invoices.component').then(c => c.InvoicesComponent),
    children: [
      {
        path: Resources.Invoices,
        loadComponent: () => import('./main/invoices-main.component').then(c => c.InvoicesMainComponent),
        data: {
          title: 'INVOICES.TABS.OVERVIEW',
          subTitle: 'INVOICES.TABS.INVOICES_SUBTITLE',
        }
      },
      {
        path: Resources.InvoicesOverview,
        loadComponent: () => import('./tabs/invoices-overivew/invoices-overivew.component').then(c => c.InvoicesOverivewComponent),
        data: {
          title: 'INVOICES.TABS.OVERVIEW',
          subTitle: 'INVOICES.TABS.OVERVIEW_SUBTITLE'
        }
      },
      {
        path: Resources.InvoicesHistory,
        loadComponent: () => import('./tabs/invoices-history/invoices-history.component').then(c => c.InvoicesHistoryComponent),
        data: {
          title: 'INVOICES.TABS.BILLING',
          subTitle: 'INVOICES.TABS.BILLING_SUBTITLE'
        }
      }
    ]
  },
] satisfies Routes;
